module.exports = __webpack_public_path__ + "img/le-mot.0f1a5d83.png";